import { combineReducers } from '@reduxjs/toolkit'

import addressChangeReducer from './address-change'
import missingContactReducer from './missing-contact'

export default combineReducers({
  addressChange: addressChangeReducer,
  missingContact: missingContactReducer,
})
